import barraProteina from '../assets/imagens/BarraDeProteina.jpg';
import pastaAmendoim from '../assets/imagens/pasta_Amendoim.jpg';
import pastaCastanha from '../assets/imagens/pasta_castanha.png';
import wheyCaixinha from '../assets/imagens/wheyCaixinha.png';
import gel from '../assets/imagens/gel.jpg';

export const opcoesRoleta: string[] = 
    [
        'Barrinha de proteína', 
        'Pasta de Amendoin', 
        'Pasta de Castanha', 
        'Whey de Caixinha', 
        'Gel energetico'
    ];



export  const imagensProdutos: { [key: string]: string} = {
        'Barrinha de proteina': barraProteina,
        'Pasta de amendoim': pastaAmendoim,
        'Pasta de Castanha': pastaCastanha,
        'Whey de Caixinha': wheyCaixinha,
        'Gel energetico': gel
    }

   
